import { TealiumTrackType } from "../types/TealiumTrackType.js";
export const buildLayer = (type, build = data => data) => (data, callback, tagIds) => [type, build(data), callback, tagIds];
export const buildLinkLayer = (build = data => data) => buildLayer(TealiumTrackType.LINK, build);
export const buildViewLayer = (build = data => data) => buildLayer(TealiumTrackType.VIEW, build);